<div class="invitation-create-container">
  <!-- Botão Voltar -->
  <button 
    mat-icon-button 
    (click)="onBack()" 
    class="back-button"
    aria-label="Voltar">
    <mat-icon>arrow_back</mat-icon>
  </button>

  <!-- Card Principal -->
  <mat-card class="invitation-card">
    <mat-card-header>
      <mat-card-title>Criar convite</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="invitationForm" (ngSubmit)="onSubmit()">
        <div formArrayName="emails" class="emails-container">
          <div 
            *ngFor="let emailControl of emailsFormArray.controls; let i = index" 
            [formGroupName]="i" 
            class="email-field-container">
            
            <mat-form-field appearance="outline" class="email-field">
              <mat-label>E-mail</mat-label>
              <input 
                matInput 
                formControlName="email" 
                type="email" 
                placeholder="exemplo@email.com">
              <mat-error *ngIf="emailControl.get('email')?.hasError('required')">
                E-mail é obrigatório
              </mat-error>
              <mat-error *ngIf="emailControl.get('email')?.hasError('email')">
                E-mail inválido
              </mat-error>
            </mat-form-field>

            <div class="email-actions">
              <!-- Botão Adicionar (apenas no último item) -->
              <button 
                *ngIf="i === emailsFormArray.length - 1 && canAddMoreEmails"
                mat-icon-button 
                type="button"
                (click)="addEmailField()"
                class="add-email-button"
                [disabled]="!canAddMoreEmails"
                aria-label="Adicionar e-mail">
                <mat-icon>add_circle</mat-icon>
              </button>

              <!-- Botão Remover (apenas se houver mais de um campo) -->
              <button 
                *ngIf="emailsFormArray.length > 1"
                mat-icon-button 
                type="button"
                (click)="removeEmailField(i)"
                class="remove-email-button"
                aria-label="Remover e-mail">
                <mat-icon>remove_circle</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- Informação sobre limite -->
        <div class="info-text" *ngIf="emailsFormArray.length >= maxEmails">
          <mat-icon class="warning-icon">info</mat-icon>
          <span>Limite máximo de {{ maxEmails }} convites atingido</span>
        </div>
      </form>
    </mat-card-content>

    <mat-card-actions class="card-actions">
      <!-- Botão Criar (à esquerda) -->
      <button 
        mat-raised-button 
        color="primary"
        (click)="onSubmit()"
        [disabled]="invitationForm.invalid || isLoading"
        class="create-button">
        <mat-icon *ngIf="isLoading">hourglass_empty</mat-icon>
        <span>{{ isLoading ? 'Criando...' : 'Criar' }}</span>
      </button>

      <!-- Espaçador -->
      <span class="spacer"></span>

      <!-- Botão Cancelar (à direita) -->
      <button 
        mat-raised-button 
        color="accent"
        (click)="onCancel()"
        [disabled]="isLoading"
        class="cancel-button">
        Cancelar
      </button>
    </mat-card-actions>
  </mat-card>
</div>
